import { render, staticRenderFns } from "./SalariesView.vue?vue&type=template&id=2179553a"
import script from "./SalariesView.vue?vue&type=script&lang=js"
export * from "./SalariesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports